import React from "react";
import {
  ScrollView,
  Text,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { Button } from "react-native-elements";
import {
  FontAwesome5,
  FontAwesome,
  AntDesign,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Foundation,
} from "@expo/vector-icons";

const HomeScreen = ({ navigation }) => {
  return (
    <ScrollView style={styles.container}>
      <View style={styles.gridContainer}>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Add")}
        >
          <Text style={styles.text}>Addition</Text>

          <FontAwesome name="plus-circle" size={35} color="yellow" />
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("AddSub")}
        >
          <Text style={styles.text}>Add/Sub</Text>
          <MaterialCommunityIcons
            name="plus-minus-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("AddSubNeg")}
        >
          <Text style={styles.text}>+/- (Neg. Ans)</Text>
          <MaterialCommunityIcons
            name="plus-minus-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("MixAddSub")}
        >
          <Text style={styles.text}>Mix(+/-)</Text>
          <MaterialCommunityIcons
            name="plus-minus-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Mul")}
        >
          <Text style={styles.text}>Multiplication</Text>
          <MaterialCommunityIcons
            name="multiplication-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("DecimalMul")}
        >
          <Text style={styles.text}>Deci. Multi.</Text>
          <MaterialCommunityIcons
            name="multiplication-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Div")}
        >
          <Text style={styles.text}>Division</Text>
          <MaterialCommunityIcons
            name="division-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("DecimalDiv")}
        >
          <Text style={styles.text}>Deci. Division</Text>
          <MaterialCommunityIcons
            name="division-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("SquareRoot")}
        >
          <Text style={styles.text}>Square Root</Text>
          <MaterialCommunityIcons
            name="square-root-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("CubeRoot")}
        >
          <Text style={styles.text}>Cube Root</Text>
          <Ionicons name="cube-sharp" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Square")}
        >
          <Text style={styles.text}>Square</Text>
          <Ionicons name="md-square-outline" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Cube")}
        >
          <Text style={styles.text}>Cube</Text>
          <FontAwesome name="cubes" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("DecimalAddition")}
        >
          <Text style={styles.text}>Decimal +</Text>
          <FontAwesome name="plus-circle" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("DecimalAddSub")}
        >
          <Text style={styles.text}>Decimal +/-</Text>
          <MaterialCommunityIcons
            name="plus-minus-box"
            size={35}
            color="yellow"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Table")}
        >
          <Text style={styles.text}>Table Prac.</Text>
          <AntDesign name="table" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("TablePractice")}
        >
          <Text style={styles.text}>Table</Text>
          <MaterialIcons name="table-chart" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Percentage")}
        >
          <Text style={styles.text}>Percentage</Text>
          <FontAwesome5 name="percentage" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Website")}
        >
          <Text style={styles.text}>Website</Text>
          <MaterialCommunityIcons name="web" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Share")}
        >
          <Text style={styles.text}>Share</Text>
          <FontAwesome5 name="share-alt" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("StopWatch")}
        >
          <Text style={styles.text}>Stop Watch</Text>
          <FontAwesome5 name="stopwatch" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Calculator")}
        >
          <Text style={styles.text}>Calculator</Text>
          <AntDesign name="calculator" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Youtube")}
        >
          <Text style={styles.text}>Youtube</Text>
          <AntDesign name="youtube" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Timer")}
        >
          <Text style={styles.text}>Timer</Text>
          <FontAwesome5 name="stopwatch" size={35} color="yellow" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.button}
          onPress={() => navigation.navigate("Memo")}
        >
          <Text style={styles.text}>Recall Num.</Text>
          <FontAwesome5 name="brain" size={35} color="yellow" />
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "black",
    flex: 1,
  },
  button: {
    alignItems: "center",
    borderWidth: 3,
    borderRadius: 15,
    borderColor: "yellow",
    padding: 10,
    margin: 10,
    width: "40%",
  },
  gridContainer: {
    flex: 1,
    margin: 5,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "space-around",
  },
  text: {
    color: "white",
    fontWeight: "bold",
    fontSize: 18,
  },
});

export default HomeScreen;
